/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Rebate programs supported by S3.
 */
export enum Programs {
  _3C_REN = '3c-ren',
  PCE = 'pce',
  RECO = 'reco',
  HIASP = 'hiasp',
  UDVE = 'udve',
  CA_HEEHRA = 'ca-heehra',
  OTHER = 'other',
  VANILLA = 'vanilla',
  WI_HEAR = 'wi-hear',
  GA_HEAR = 'ga-hear',
  _3CE = '3ce',
  CA_TECH = 'ca-tech',
  CA_TECH_WATER_HEATER = 'ca-tech-water-heater',
  SUNRUN = 'sunrun',
  MASS_SAVE = 'mass-save',
  NY_CLEAN_HEAT = 'ny-clean-heat',
  NY_CLEAN_HEAT_CONED = 'ny-clean-heat-coned',
  CO_XCEL = 'co-xcel',
  CO_HEAR = 'co-hear',
  CO_DR_COG = 'co-dr-cog',
  CA_TECH_SFV = 'ca-tech-sfv',
  CO_XCEL_AURORA = 'co-xcel-aurora',
  LADWP = 'ladwp',
  WI_HEAR_WX = 'wi-hear-wx',
  CO_XCEL_MOUNTAIN_ENERGY = 'co-xcel-mountain-energy',
}
